import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "white-bg"
};
const _hoisted_2 = {
  class: "common-header"
};
const _hoisted_3 = {
  class: "clearfix"
};
const _hoisted_4 = {
  class: "no-border"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[0] || (_cache[0] = _createElementVNode("a", {
    class: "logo-href",
    href: "#/"
  }, null, -1)), _createElementVNode("ul", _hoisted_3, [_createElementVNode("li", _hoisted_4, [_createElementVNode("a", {
    class: _normalizeClass(["index", {
      'on': _ctx.$route.path == '/download'
    }]),
    href: "#/download"
  }, "下载APP", 2)]), _createElementVNode("li", null, [_createElementVNode("a", {
    class: _normalizeClass(["active", {
      'on': _ctx.$route.path == '/dynamic'
    }]),
    href: "#/dynamic"
  }, "公司动态", 2)]), _createElementVNode("li", null, [_createElementVNode("a", {
    class: _normalizeClass(["active", {
      'on': _ctx.$route.path == '/company'
    }]),
    href: "#/company"
  }, "公司简介", 2)]), _createElementVNode("li", null, [_createElementVNode("a", {
    class: _normalizeClass(["active", {
      'on': _ctx.$route.path == '/help'
    }]),
    href: "#/help"
  }, "帮助中心", 2)]), _createElementVNode("li", null, [_createElementVNode("a", {
    class: _normalizeClass(["active", {
      'on': _ctx.$route.path == '/join'
    }]),
    href: "#/join"
  }, "加入我们", 2)]), _createElementVNode("li", null, [_createElementVNode("a", {
    class: _normalizeClass(["active", {
      'on': _ctx.$route.path == '/connect'
    }]),
    href: "#/connect"
  }, "联系我们 ", 2)])])])]);
}